import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core'

class ModalVerifyAdoptionMode extends Component {
  constructor(props) {
    super(props)

    this.state = {
      adoptionModeOption: 'alwaysUpdateChild',
    }
  }

  handleAdoptionMode = (event) => {
    this.setState({
      adoptionModeOption: event.target.value,
    })
  }

  handleNewAdoptionModeOption = () => {
    const { adoptionModeOption } = this.state
    localStorage.setItem('ADOPTION_MODE_VERIFY', JSON.stringify(adoptionModeOption))
    this.props.handleContinueVerifyAdoptionMode()
  }

  render() {
    const { open, close } = this.props
    const { adoptionModeOption } = this.state
    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Adoption Mode - Child Selection</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          <span className={'text-description-adoption-mode'}>
            Would you like update the child values with the Parent now? Or create overrides
            preserving the child’s current values.
          </span>
          <div className="container-input-radios">
            <RadioGroup
              aria-label="adoption-mode-options"
              name="adoption-mode-options"
              value={adoptionModeOption}
              onChange={this.handleAdoptionMode}
            >
              <FormControlLabel
                value="alwaysUpdateChild"
                control={<Radio />}
                label="Update Child"
              />
              <FormControlLabel
                value="alwaysCreateOverrides"
                control={<Radio />}
                label="Do not update - create overrides"
              />
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions className="container-buttons-adoption-mode">
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={this.handleNewAdoptionModeOption} className="button-blue-and-white">
            <span className="button-text">Continue</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ModalVerifyAdoptionMode



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalVerifyAdoptionMode.js